<a *ngIf="componentId && source" routerLink="/traceable-component/{{source}}/{{componentId}}">
    {{ componentId }}
</a>